'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _reactApollo = require('react-apollo');

var _View = require('./View');

var _View2 = _interopRequireDefault(_View);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ProjectAutocomplete = (_temp2 = _class = function (_PrismaCmsComponent) {
  _inherits(ProjectAutocomplete, _PrismaCmsComponent);

  function ProjectAutocomplete() {
    var _temp, _this, _ret;

    _classCallCheck(this, ProjectAutocomplete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PrismaCmsComponent.call.apply(_PrismaCmsComponent, [this].concat(args))), _this), _this.onSelect = function (value, item) {
      _this.setObjectId(item.id);
    }, _this.resetData = function () {
      _this.setState({
        // item: null,
        objectId: null
      });

      _this.cleanFilters();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ProjectAutocomplete.prototype.componentWillMount = function componentWillMount() {
    var projects = this.context.query.projects;
    var View = this.props.View;
    this.Renderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(projects))(View);
    _PrismaCmsComponent.prototype.componentWillMount && _PrismaCmsComponent.prototype.componentWillMount.call(this);
  };

  ProjectAutocomplete.prototype.onChange = function onChange(event) {
    var value = event.target.value; // this.setState({
    //   value,
    // }, () => this.loadData());

    this.setFilters({
      projectQuery: value
    });
  };

  ProjectAutocomplete.prototype.setObjectId = function setObjectId(objectId) {
    this.setState({
      objectId: objectId
    });
  };

  ProjectAutocomplete.prototype.getObjectId = function getObjectId() {
    var objectId = this.state.objectId;
    return objectId;
  };

  ProjectAutocomplete.prototype.render = function render() {
    var _this2 = this;

    var Renderer = this.Renderer;

    var _props = this.props,
        View = _props.View,
        label = _props.label,
        helperText = _props.helperText,
        error = _props.error,
        inputProps = _props.inputProps,
        other = _objectWithoutProperties(_props, ['View', 'label', 'helperText', 'error', 'inputProps']);

    _objectDestructuringEmpty(this.state);

    var objectId = this.getObjectId();
    var filters = this.getFilters(); // console.log("filters", filters);

    var _ref = filters || {},
        name_contains = _ref.projectQuery;

    return _PrismaCmsComponent.prototype.render.call(this, _react2.default.createElement(Renderer, _extends({}, other, {
      onChange: function onChange(event) {
        return _this2.onChange(event);
      },
      onSelect: function onSelect(value, item) {
        return _this2.onSelect(value, item);
      },
      resetData: function resetData() {
        return _this2.resetData();
      },
      value: name_contains || "",
      where: {
        name_contains: name_contains // item={item}

      },
      objectId: objectId,
      inputProps: _extends({
        label: label,
        helperText: helperText,
        error: error
      }, inputProps)
    })));
  };

  return ProjectAutocomplete;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  View: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  View: _View2.default,
  first: 10,
  orderBy: "name_ASC",
  label: "Проект"
}), _temp2);
exports.default = ProjectAutocomplete;
module.exports = exports['default'];